<template>
    <div id="cliente-indicacao">
    <my-tour v-if="checkContent && itens.length > 0 || semItem" :steps="steps" name="steps-indicacao"></my-tour>
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Indicação de clientes" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                        <!-- <div class="row" v-if="itens.length === 0">
                            <div class="col s12 m12 l12">
                                <div class="card gradient-45deg-purple-deep-orange gradient-shadow">
                                    <div class="card-content white-text">
                                        <p>Nenhuma indicação a ser feita</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <ContainerAlert :show="!checkContent"  message=" Carregando Leads..." />
                        <ContainerAlert :show="itens.length === 0 && checkContent"  message="Nenhum Lead cadastrado!" />

                        <table class="table-responsive bordered striped" v-if="itens.length > 0">
                            <thead>
                            <tr>
                                <th class="colNome">Nome</th>
                                <th class="colObs hide-on-med-and-down" style="width:300px;">Observação</th>
                                <th class="colProduto">Produto</th>
                                <!--<th class="colEstado">Estado</th>
                                <th class="colCamanha">Campanha</th> -->
                                <th class="colAutor">Autor</th>
                                <th>Empresa</th>
                                <th id="colResponsavelIndicacao" class="colResponsavel">Consultor responsável</th>
                                <th id="colAcoesIndicacao" class="colAcoes center">Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in paginationConfig.itens" :id="'item-'+item.pedido_id">
                                    <td class="colNome">
                                        <template v-if="item.cliente_has_produto.cliente">
                                            {{ item.cliente_has_produto.cliente.pessoa.pessoa_nome }}
                                        </template>
                                    </td>
                                    <td class="colObs  hide-on-med-and-down">
                                        <template v-if="item.cliente_has_produto.cliente">
                                            {{ item.cliente_has_produto.cliente.pessoa.pessoa_observacao }}
                                        </template>
                                    </td>
                                    <td class="colProduto">{{ item.cliente_has_produto.produto.produto_nome }}</td>
                                   <!-- <td class="colEstado">{{ item.pedido_historico.pedido_estagio.pedido_estagio_nome }}</td>
                                     <td class="colCamanha">{{ item.cliente_has_produto.cliente.campanha_id }}</td> -->
                                    <td class="colAutor">
                                        <div v-if="item.funcionario" >
                                            <img
                                                :src="item.funcionario.pessoa.pessoa_avatar_url"
                                                v-if="item.funcionario.pessoa.pessoa_avatar"
                                            >
                                            {{ item.funcionario.pessoa.pessoa_nome }}
                                        </div>
                                        <strong v-else>SITE</strong>
                                    </td>
                                    <td >
                                        {{ item.funcionario.empresa ? item.funcionario.empresa.empresa_nome_fantasia : ' - ' }}
                                    </td>
                                    <td id="colResponsavel" class="colResponsavel">
                                        <select class="browser-default" v-model="item.indicado_id">
                                            <option value="" disabled selected>Selecione um responsavel</option>
                                            <option :value="null">Não indicar para ninguém</option>
                                            <option v-for="responsavel in responsaveis" :value="responsavel.funcionario_id" :selected="item.responsavel_id === responsavel.funcionario_id">{{ responsavel.pessoa.pessoa_nome }}</option>
                                        </select>
                                    </td>
                                    <td class="colAcoes center">
                                        <a v-if="item.responsavel_id === null" class="btn-floating waves-effect waves-light gradient-45deg-light-blue-cyan gradient-shadow">
                                            <i class="material-icons">add</i>
                                        </a>
                                        <button id="check-indication" @click="indicarCorretor(item)" v-if="item.responsavel_id !== null"  v-tooltip.bottom="'Confirmar'" class="btn-flat waves-effect btn-floating btn-transparent">
                                            <i class="material-icons green-text">check</i>
                                        </button>
                                        <botao-remover :identificador="item.pedido_id" :url="'pedido/'+item.pedido_id"></botao-remover>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                         <Pagination v-if="itens.length > 0" :perPage="paginationConfig.perPage" :qty="paginationConfig.qty" :setCurrent="setCurrent" :current="paginationConfig.current" />
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<style>
    #cliente-indicacao{
        min-height: 100vh;
    }
    #cliente-indicacao .colAcoes {
        width: 10%;
    }

    @media screen and (max-width: 768px) {
        #cliente-indicacao .colAcoes {
            width: 20%;
        }

        #cliente-indicacao .colProduto {
            display: none;
        }
        #cliente-indicacao .colEstado {
            display: none;
        }
        #cliente-indicacao .colCamanha {
            display: none;
        }
        #cliente-indicacao .colAutor {
            display: none;
        }
    }
    .colAutor img{
        float: left;
        margin: 0 8px 0 -12px;
        height: 32px;
        width: 32px;
        border-radius: 50%;
    }
    tr td{
        text-transform: uppercase;
    }
</style>
<script>
import { get, post, api } from '@/helpers/api';
import BotaoRemover from '@/components/common/BotaoRemover';
import TituloPagina from '@/components/common/TituloPagina';
import MyTour from '@/components/common/MyTour.vue';
import ContainerAlert from '@/components/common/ContainerAlert/ContainerAlert';
import Pagination from '@/components/common/Pagination/Pagination';
import ListHelper from '@/helpers/list';
import Message from '@/helpers/message';
import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER, PARCEIRO } from '@/constants/funcionarioCargo.js';
import Auth from '@/store/auth';

import TourHelper from '@/helpers/tour';
export default {
    components: {
        BotaoRemover,
        TituloPagina,
        MyTour,
        Pagination,
        ContainerAlert
    },
    data: () => ({
            paginationConfig: {
            perPage: 20,
            qty: 1,
            current: 1,
            itens: []
        },
        itens: [],
        responsaveis: [],
        cargoDono: null,
        cargoGerente: null,
        cargoCorretor: null,
        cargoParceiro: null,
        checkContent: false,
        semItem: false,
        steps: [
            {
                parent: '#colResponsavelIndicacao',
                target: '#colResponsavelIndicacao',
                content: 'Para indicar um responsável basta selecionar o nome do mesmo neste campo!',
                params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },
            {
                parent: '#colAcoesIndicacao',
                target: '#colAcoesIndicacao',
                content: 'Para confirmar a escolha ou excluir o Lead indicado, temos as ações específica para estes casos!',
                params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },

            {
                parent: '#left-sidebar-nav',
                target: '#importacao-cliente',
                content: 'Para importar Leads, basta no menu Cliente clicar em <b>Importação</b>!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: true,
                    route: '/clientes/importacao',
                    subMenu: true,
                    subMenuTarget:"#group-cliente"
                }
            },
            {

                parent: '',
                target: '',
                content: '',
                params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false,
                    // route: '/gerenciamento-leads'
                }
            },
            ],
    }),
    created() {

        // verifica se pode acessar componente
        // if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1) {
        //     this.$router.push('/sempermissao');
        // }

        this.steps = TourHelper.createSteps(this.steps);
        let self = this;
        this.cargoDono = DONO;
        this.cargoGerente = GERENTE;
        this.cargoCorretor = CORRETOR;
        get('pedido').then(function (response) {
            self.itens = response.data.result.data;

            self.paginationConfig.qty   = self.itens.length;
            self.paginationConfig.itens = ListHelper.getInterval(self.itens, self.paginationConfig.current, self.paginationConfig.perPage);
            self.checkContent = true;
            self.semItem = self.itens.length === 0;
            if(self.semItem){
                    self.steps =[
                        {

                    parent: '#cliente-indicacao .card-panel',
                    target: '#cliente-indicacao .card-panel',
                    content: 'Clientes para indicação serão exibidos aqui!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'bottom',
                        menu: false,
                        route: '/gerenciamento-leads'
                    }
                },
                    {
                parent: '#left-sidebar-nav',
                target: '#importacao-cliente',
                content: 'Para importar Leads, basta no menu Cliente clicar em <b>Importação</b>!',
                    params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                        placement: 'left',
                        menu: true,
                        route: '/clientes/importacao',
                        subMenu: true,
                        subMenuTarget:"#group-cliente"
                }
            },
            {
                parent: '',
                target: '',
                content: '',
                params: { cargos: [PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false,
                    // route: '/gerenciamento-leads'
                }
            },
                ]
            }
            self.steps = TourHelper.createSteps(self.steps);
        });

        get('funcionario/corretores').then(function (response) {
            self.responsaveis = response.data.result.data;
        });
    },
    watch:{
        'paginationConfig.current'(){
            this.paginationConfig.itens = ListHelper.getInterval(this.itens, this.paginationConfig.current, this.paginationConfig.perPage);
        },
    },
    methods: {
        setCurrent(current){
            this.paginationConfig.current = current;
        },
        indicarCorretor(item) {
            let self = this;

            api.post('processo/indicacao-corretor',{
                pedido_id: item.pedido_id,
                funcionario_id: item.indicado_id
            }).then(function () {
                let index = self.itens.findIndex(i => i.pedido_id === item.pedido_id);
                self.itens.splice(index,1);

                Message.messageSuccess(item.indicado_id ? 'Indicado com sucesso.' : 'Ignorado com sucesso', 3000, 'rouded green');

                $('#item-'+item.pedido_id).remove();
            }).catch(function (error) {
                Message.messageSuccess('Erro ao indicar.', 3000, 'rouded red');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/Indicacao.vue